import type { BuilderType } from '@shared/utils/api/configs/rtkBaseQueryDemo';
import { GET_OUTSTANDING_BILLS_URL } from '@shared/utils/api/configs/URL';
import { hasCcdpPartialSuccess, hasCcdpSuccess } from '@shared/utils/api/handlers/interpretCcdpCode/interpretCcdpCode';
import type { GenericApiResponse } from '@shared/utils/api/types';

import type {
  GetInvoiceOutstandingPayload,
  GetInvoiceOutstandingResult,
} from '../types/getOutstandingBills.types';

export const INVOICE_OUTSTANDING = 'OutstandingBill';

export const getInvoiceOutstanding = (builder: BuilderType) =>
  builder.query<GetInvoiceOutstandingResult, GetInvoiceOutstandingPayload>({
    keepUnusedDataFor: 0,
    providesTags: [INVOICE_OUTSTANDING],
    query: (data) => ({
      data,
      method: 'POST',
      url: GET_OUTSTANDING_BILLS_URL,
    }),
    transformResponse: (response: GenericApiResponse<GetInvoiceOutstandingResult>) => {
      if (hasCcdpSuccess(response) || hasCcdpPartialSuccess(response)) {
        return {
          ...response.Result,
          message: response.Message,
          status: response.Status,
        };
      }
      throw {
        code: response.Code,
        message: response.Message,
      };
    },
  });
